import API from "@/package/config/axios";
import { IPlaceReviewsResponse } from "@/modules/place-module";

export const apiGetPlaceReviews = (
  placeId: number,
  params?: { page: number; rating: Array<string> }
) => {
  return API.get<IPlaceReviewsResponse>(`api/v2/places/${placeId}/reviews`, {
    params: params,
  });
};

export const apiLeavePlaceFeedback = (
  placeId: number,
  feedback: { rating: number; message: string }
) => {
  return API.post(`api/v2/places/${placeId}/review`, feedback);
};
